// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "finance.voltage",
    name: "Volt: DeFi",
    homepage: "https://voltage.finance/app",
    image_id: "51d783cb-0686-4ffa-e661-edca0c380000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/volt-defi/id6444159237",
        android: "https://play.google.com/store/apps/details?id=finance.voltage.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "volt://",
        universal: "https://get.voltage.finance",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map